/* Gerado por tools/import-pokeidle-loot.mjs — não editar à mão. */
export const IMPORTED_LOOT = [
  {
    "slug": "air-tank",
    "name": "Air Tank",
    "sell": 250,
    "rare": true,
    "img": "public/assets/items/air-tank.png",
    "npcPrice": 1000
  },
  {
    "slug": "armadillo-claw",
    "name": "Armadillo Claw",
    "sell": 97,
    "rare": false,
    "img": "public/assets/items/armadillo-claw.png",
    "npcPrice": 147
  },
  {
    "slug": "bag-of-pollen",
    "name": "Bag of Pollen",
    "sell": 47,
    "rare": false,
    "img": "public/assets/items/bag-of-pollen.png",
    "npcPrice": 40
  },
  {
    "slug": "band-aid",
    "name": "Band Aid",
    "sell": 2,
    "rare": false,
    "img": "public/assets/items/band-aid.png",
    "npcPrice": 1
  },
  {
    "slug": "bat-wing",
    "name": "Bat Wing",
    "sell": 67,
    "rare": false,
    "img": "public/assets/items/bat-wing.png",
    "npcPrice": 78
  },
  {
    "slug": "bee-sting",
    "name": "Bee Sting",
    "sell": 57,
    "rare": true,
    "img": "public/assets/items/bee-sting.png",
    "npcPrice": 54
  },
  {
    "slug": "drop-champion-belt",
    "name": "Belt of Champion",
    "sell": 250,
    "rare": true,
    "img": "public/assets/items/drop-champion-belt.png",
    "npcPrice": 1000
  },
  {
    "slug": "bird-beak",
    "name": "Bird Beak",
    "sell": 39,
    "rare": false,
    "img": "public/assets/items/bird-beak.png",
    "npcPrice": 30
  },
  {
    "slug": "bitten-apple",
    "name": "Bitten Apple",
    "sell": 21,
    "rare": false,
    "img": "public/assets/items/bitten-apple.png",
    "npcPrice": 7
  },
  {
    "slug": "blue-fish-fin",
    "name": "Blue Fish Fin",
    "sell": 169,
    "rare": true,
    "img": "public/assets/items/blue-fish-fin.png",
    "npcPrice": 500
  },
  {
    "slug": "blue-vines",
    "name": "Blue Vines",
    "sell": 169,
    "rare": true,
    "img": "public/assets/items/blue-vines.png",
    "npcPrice": 500
  },
  {
    "slug": "drop-bone",
    "name": "Bone",
    "sell": 87,
    "rare": false,
    "img": "public/assets/items/drop-bone.png",
    "npcPrice": 123
  },
  {
    "slug": "drop-poison-bottle",
    "name": "Bottles of Poison",
    "sell": 2,
    "rare": false,
    "img": "public/assets/items/drop-poison-bottle.png",
    "npcPrice": 1
  },
  {
    "slug": "drop-bug-antenna",
    "name": "Bug Antenna",
    "sell": 75,
    "rare": false,
    "img": "public/assets/items/drop-bug-antenna.png",
    "npcPrice": 96
  },
  {
    "slug": "bug-gosme",
    "name": "Bug Gosme",
    "sell": 2,
    "rare": false,
    "img": "public/assets/items/bug-gosme.png",
    "npcPrice": 1
  },
  {
    "slug": "bug-venom",
    "name": "Bug Venom",
    "sell": 148,
    "rare": false,
    "img": "public/assets/items/bug-venom.png",
    "npcPrice": 371
  },
  {
    "slug": "bulb",
    "name": "Bulb",
    "sell": 91,
    "rare": true,
    "img": "public/assets/items/bulb.png",
    "npcPrice": 132
  },
  {
    "slug": "bull-tail",
    "name": "Bull Tail",
    "sell": 169,
    "rare": true,
    "img": "public/assets/items/bull-tail.png",
    "npcPrice": 500
  },
  {
    "slug": "butterfly-wing",
    "name": "Butterfly Wing",
    "sell": 62,
    "rare": true,
    "img": "public/assets/items/butterfly-wing.png",
    "npcPrice": 66
  },
  {
    "slug": "chansey-egg",
    "name": "Chansey Egg",
    "sell": 169,
    "rare": true,
    "img": "public/assets/items/chansey-egg.png",
    "npcPrice": 500
  },
  {
    "slug": "chicken-feet",
    "name": "Chicken Feet",
    "sell": 169,
    "rare": true,
    "img": "public/assets/items/chicken-feet.png",
    "npcPrice": 500
  },
  {
    "slug": "colored-feather",
    "name": "Colored Feather",
    "sell": 106,
    "rare": true,
    "img": "public/assets/items/colored-feather.png",
    "npcPrice": 168
  },
  {
    "slug": "comb",
    "name": "Comb",
    "sell": 77,
    "rare": false,
    "img": "public/assets/items/comb.png",
    "npcPrice": 100
  },
  {
    "slug": "crab-claw",
    "name": "Crab Claw",
    "sell": 72,
    "rare": false,
    "img": "public/assets/items/crab-claw.png",
    "npcPrice": 90
  },
  {
    "slug": "crystal-cube",
    "name": "Crystal Cube",
    "sell": 169,
    "rare": true,
    "img": "public/assets/items/crystal-cube.png",
    "npcPrice": 500
  },
  {
    "slug": "crystal-tail",
    "name": "Crystal Tail",
    "sell": 169,
    "rare": true,
    "img": "public/assets/items/crystal-tail.png",
    "npcPrice": 500
  },
  {
    "slug": "dark-gem",
    "name": "Dark Gem",
    "sell": 2,
    "rare": false,
    "img": "public/assets/items/dark-gem.png",
    "npcPrice": 1
  },
  {
    "slug": "diving-mask",
    "name": "Diving Mask",
    "sell": 250,
    "rare": true,
    "img": "public/assets/items/diving-mask.png",
    "npcPrice": 1000
  },
  {
    "slug": "dodo-cube",
    "name": "Dodo Cube",
    "sell": 169,
    "rare": true,
    "img": "public/assets/items/dodo-cube.png",
    "npcPrice": 500
  },
  {
    "slug": "dodrio-feather",
    "name": "Dodrio Feather",
    "sell": 78,
    "rare": false,
    "img": "public/assets/items/dodrio-feather.png",
    "npcPrice": 102
  },
  {
    "slug": "dome-fossil",
    "name": "Dome Fossil",
    "sell": 169,
    "rare": true,
    "img": "public/assets/items/dome-fossil.png",
    "npcPrice": 500
  },
  {
    "slug": "dragon-scale",
    "name": "Dragon Scale",
    "sell": 2,
    "rare": false,
    "img": "public/assets/items/dragon-scale.png",
    "npcPrice": 1
  },
  {
    "slug": "dragon-tail",
    "name": "Dragon Tail",
    "sell": 169,
    "rare": true,
    "img": "public/assets/items/dragon-tail.png",
    "npcPrice": 500
  },
  {
    "slug": "drop-dragon-tooth",
    "name": "Dragon Tooth",
    "sell": 187,
    "rare": true,
    "img": "public/assets/items/drop-dragon-tooth.png",
    "npcPrice": 610
  },
  {
    "slug": "earth-ball",
    "name": "Earth Ball",
    "sell": 2,
    "rare": false,
    "img": "public/assets/items/earth-ball.png",
    "npcPrice": 1
  },
  {
    "slug": "drop-electric-box",
    "name": "Electric Box",
    "sell": 31,
    "rare": false,
    "img": "public/assets/items/drop-electric-box.png",
    "npcPrice": 20
  },
  {
    "slug": "electric-rat-tail",
    "name": "Electric Rat Tail",
    "sell": 91,
    "rare": false,
    "img": "public/assets/items/electric-rat-tail.png",
    "npcPrice": 132
  },
  {
    "slug": "electric-tail",
    "name": "Electric Tail",
    "sell": 169,
    "rare": true,
    "img": "public/assets/items/electric-tail.png",
    "npcPrice": 500
  },
  {
    "slug": "enchanted-gem",
    "name": "Enchanted Gem",
    "sell": 2,
    "rare": false,
    "img": "public/assets/items/enchanted-gem.png",
    "npcPrice": 1
  },
  {
    "slug": "drop-essence-fire",
    "name": "Essence of Fire",
    "sell": 2,
    "rare": false,
    "img": "public/assets/items/drop-essence-fire.png",
    "npcPrice": 1
  },
  {
    "slug": "farfetchd-stick",
    "name": "Farfetchd Stick",
    "sell": 136,
    "rare": false,
    "img": "public/assets/items/farfetchd-stick.png",
    "npcPrice": 300
  },
  {
    "slug": "drop-feather",
    "name": "Feather",
    "sell": 21,
    "rare": false,
    "img": "public/assets/items/drop-feather.png",
    "npcPrice": 8
  },
  {
    "slug": "female-ear",
    "name": "Female Ear",
    "sell": 97,
    "rare": true,
    "img": "public/assets/items/female-ear.png",
    "npcPrice": 147
  },
  {
    "slug": "fins",
    "name": "Fins",
    "sell": 250,
    "rare": true,
    "img": "public/assets/items/fins.png",
    "npcPrice": 1000
  },
  {
    "slug": "fire-horse-foot",
    "name": "Fire Horse Foot",
    "sell": 83,
    "rare": false,
    "img": "public/assets/items/fire-horse-foot.png",
    "npcPrice": 114
  },
  {
    "slug": "fire-tail",
    "name": "Fire Tail",
    "sell": 91,
    "rare": true,
    "img": "public/assets/items/fire-tail.png",
    "npcPrice": 132
  },
  {
    "slug": "fish-fin",
    "name": "Fish Fin",
    "sell": 169,
    "rare": true,
    "img": "public/assets/items/fish-fin.png",
    "npcPrice": 500
  },
  {
    "slug": "drop-fox-tail",
    "name": "Fox Tail",
    "sell": 250,
    "rare": true,
    "img": "public/assets/items/drop-fox-tail.png",
    "npcPrice": 1000
  },
  {
    "slug": "fur",
    "name": "Fur",
    "sell": 25,
    "rare": false,
    "img": "public/assets/items/fur.png",
    "npcPrice": 13
  },
  {
    "slug": "future-orb",
    "name": "Future Orb",
    "sell": 28,
    "rare": false,
    "img": "public/assets/items/future-orb.png",
    "npcPrice": 16
  },
  {
    "slug": "drop-ghost-essence",
    "name": "Ghost Essence",
    "sell": 2,
    "rare": false,
    "img": "public/assets/items/drop-ghost-essence.png",
    "npcPrice": 1
  },
  {
    "slug": "giant-fin",
    "name": "Giant Fin",
    "sell": 169,
    "rare": true,
    "img": "public/assets/items/giant-fin.png",
    "npcPrice": 500
  },
  {
    "slug": "giant-piece-of-fur",
    "name": "Giant Piece of Fur",
    "sell": 111,
    "rare": false,
    "img": "public/assets/items/giant-piece-of-fur.png",
    "npcPrice": 180
  },
  {
    "slug": "giant-ruby",
    "name": "Giant Ruby",
    "sell": 120,
    "rare": true,
    "img": "public/assets/items/giant-ruby.png",
    "npcPrice": 200
  },
  {
    "slug": "goggles",
    "name": "Goggles",
    "sell": 169,
    "rare": true,
    "img": "public/assets/items/goggles.png",
    "npcPrice": 500
  },
  {
    "slug": "gosme",
    "name": "Gosme",
    "sell": 67,
    "rare": false,
    "img": "public/assets/items/gosme.png",
    "npcPrice": 78
  },
  {
    "slug": "gyarados-tail",
    "name": "Gyarados Tail",
    "sell": 169,
    "rare": true,
    "img": "public/assets/items/gyarados-tail.png",
    "npcPrice": 500
  },
  {
    "slug": "helix-fossil",
    "name": "Helix Fossil",
    "sell": 169,
    "rare": true,
    "img": "public/assets/items/helix-fossil.png",
    "npcPrice": 500
  },
  {
    "slug": "horn",
    "name": "Horn",
    "sell": 35,
    "rare": false,
    "img": "public/assets/items/horn.png",
    "npcPrice": 25
  },
  {
    "slug": "horn-drill",
    "name": "Horn Drill",
    "sell": 169,
    "rare": true,
    "img": "public/assets/items/horn-drill.png",
    "npcPrice": 500
  },
  {
    "slug": "drop-ice-orb",
    "name": "Ice Orb",
    "sell": 41,
    "rare": false,
    "img": "public/assets/items/drop-ice-orb.png",
    "npcPrice": 33
  },
  {
    "slug": "iron-bracelet",
    "name": "Iron Bracelet",
    "sell": 83,
    "rare": true,
    "img": "public/assets/items/iron-bracelet.png",
    "npcPrice": 114
  },
  {
    "slug": "kanga-ear",
    "name": "Kanga Ear",
    "sell": 169,
    "rare": true,
    "img": "public/assets/items/kanga-ear.png",
    "npcPrice": 500
  },
  {
    "slug": "karate-duck",
    "name": "Karate Duck",
    "sell": 87,
    "rare": false,
    "img": "public/assets/items/karate-duck.png",
    "npcPrice": 123
  },
  {
    "slug": "kick-machine",
    "name": "Kick Machine",
    "sell": 92,
    "rare": false,
    "img": "public/assets/items/kick-machine.png",
    "npcPrice": 135
  },
  {
    "slug": "leaves",
    "name": "Leaves",
    "sell": 22,
    "rare": false,
    "img": "public/assets/items/leaves.png",
    "npcPrice": 9
  },
  {
    "slug": "linearly-guided-hypnosis",
    "name": "Linearly Guided Hypnosis",
    "sell": 154,
    "rare": false,
    "img": "public/assets/items/linearly-guided-hypnosis.png",
    "npcPrice": 410
  },
  {
    "slug": "locksmith-of-shell",
    "name": "Locksmith of Shell",
    "sell": 34,
    "rare": false,
    "img": "public/assets/items/locksmith-of-shell.png",
    "npcPrice": 24
  },
  {
    "slug": "drop-luck-medal",
    "name": "Luck Medallion",
    "sell": 250,
    "rare": true,
    "img": "public/assets/items/drop-luck-medal.png",
    "npcPrice": 1000
  },
  {
    "slug": "magikarp-fin",
    "name": "Magikarp Fin",
    "sell": 3,
    "rare": false,
    "img": "public/assets/items/magikarp-fin.png",
    "npcPrice": 3
  },
  {
    "slug": "magma-foot",
    "name": "Magma Foot",
    "sell": 169,
    "rare": true,
    "img": "public/assets/items/magma-foot.png",
    "npcPrice": 500
  },
  {
    "slug": "magnet",
    "name": "Magnet",
    "sell": 72,
    "rare": false,
    "img": "public/assets/items/magnet.png",
    "npcPrice": 90
  },
  {
    "slug": "magnetic-cube",
    "name": "Magnetic Cube",
    "sell": 169,
    "rare": true,
    "img": "public/assets/items/magnetic-cube.png",
    "npcPrice": 500
  },
  {
    "slug": "male-ear",
    "name": "Male Ear",
    "sell": 97,
    "rare": true,
    "img": "public/assets/items/male-ear.png",
    "npcPrice": 147
  },
  {
    "slug": "martial-arts-scroll",
    "name": "Martial Arts Scroll",
    "sell": 114,
    "rare": false,
    "img": "public/assets/items/martial-arts-scroll.png",
    "npcPrice": 185
  },
  {
    "slug": "microphone",
    "name": "Microphone",
    "sell": 97,
    "rare": true,
    "img": "public/assets/items/microphone.png",
    "npcPrice": 147
  },
  {
    "slug": "mimic-clothes",
    "name": "Mimic Clothes",
    "sell": 169,
    "rare": true,
    "img": "public/assets/items/mimic-clothes.png",
    "npcPrice": 500
  },
  {
    "slug": "mushroom",
    "name": "Mushroom",
    "sell": 83,
    "rare": false,
    "img": "public/assets/items/mushroom.png",
    "npcPrice": 114
  },
  {
    "slug": "nail",
    "name": "Nail",
    "sell": 23,
    "rare": false,
    "img": "public/assets/items/nail.png",
    "npcPrice": 10
  },
  {
    "slug": "neodymium-magnet",
    "name": "Neodymium Magnet",
    "sell": 169,
    "rare": true,
    "img": "public/assets/items/neodymium-magnet.png",
    "npcPrice": 500
  },
  {
    "slug": "old-amber",
    "name": "Old Amber",
    "sell": 169,
    "rare": true,
    "img": "public/assets/items/old-amber.png",
    "npcPrice": 500
  },
  {
    "slug": "onix-tail",
    "name": "Onix Tail",
    "sell": 148,
    "rare": false,
    "img": "public/assets/items/onix-tail.png",
    "npcPrice": 371
  },
  {
    "slug": "piece-of-diglett",
    "name": "Piece of Diglett",
    "sell": 67,
    "rare": false,
    "img": "public/assets/items/piece-of-diglett.png",
    "npcPrice": 78
  },
  {
    "slug": "piece-of-steel",
    "name": "Piece of Steel",
    "sell": 2,
    "rare": false,
    "img": "public/assets/items/piece-of-steel.png",
    "npcPrice": 1
  },
  {
    "slug": "pinsir-horn",
    "name": "Pinsir Horn",
    "sell": 169,
    "rare": true,
    "img": "public/assets/items/pinsir-horn.png",
    "npcPrice": 500
  },
  {
    "slug": "plant-foot",
    "name": "Plant Foot",
    "sell": 87,
    "rare": true,
    "img": "public/assets/items/plant-foot.png",
    "npcPrice": 123
  },
  {
    "slug": "plant-tail",
    "name": "Plant Tail",
    "sell": 83,
    "rare": true,
    "img": "public/assets/items/plant-tail.png",
    "npcPrice": 114
  },
  {
    "slug": "pot-of-lava",
    "name": "Pot Of Lava",
    "sell": 29,
    "rare": false,
    "img": "public/assets/items/pot-of-lava.png",
    "npcPrice": 18
  },
  {
    "slug": "pot-of-lava",
    "name": "Pot of Lava",
    "sell": 29,
    "rare": false,
    "img": "public/assets/items/pot-of-lava.png",
    "npcPrice": 18
  },
  {
    "slug": "pot-of-moss-bug",
    "name": "Pot of Moss Bug",
    "sell": 21,
    "rare": false,
    "img": "public/assets/items/pot-of-moss-bug.png",
    "npcPrice": 8
  },
  {
    "slug": "psychic-spoon",
    "name": "Psychic Spoon",
    "sell": 111,
    "rare": true,
    "img": "public/assets/items/psychic-spoon.png",
    "npcPrice": 180
  },
  {
    "slug": "psyduck-mug",
    "name": "Psyduck Mug",
    "sell": 89,
    "rare": false,
    "img": "public/assets/items/psyduck-mug.png",
    "npcPrice": 129
  },
  {
    "slug": "punch-machine",
    "name": "Punch Machine",
    "sell": 92,
    "rare": false,
    "img": "public/assets/items/punch-machine.png",
    "npcPrice": 135
  },
  {
    "slug": "rat-tail",
    "name": "Rat Tail",
    "sell": 57,
    "rare": true,
    "img": "public/assets/items/rat-tail.png",
    "npcPrice": 54
  },
  {
    "slug": "red-wing",
    "name": "Red Wing",
    "sell": 83,
    "rare": true,
    "img": "public/assets/items/red-wing.png",
    "npcPrice": 114
  },
  {
    "slug": "rubber-ball",
    "name": "Rubber Ball",
    "sell": 2,
    "rare": false,
    "img": "public/assets/items/rubber-ball.png",
    "npcPrice": 1
  },
  {
    "slug": "ruby",
    "name": "Ruby",
    "sell": 77,
    "rare": false,
    "img": "public/assets/items/ruby.png",
    "npcPrice": 100
  },
  {
    "slug": "sandbag",
    "name": "Sandbag",
    "sell": 27,
    "rare": false,
    "img": "public/assets/items/sandbag.png",
    "npcPrice": 15
  },
  {
    "slug": "screw",
    "name": "Screw",
    "sell": 2,
    "rare": false,
    "img": "public/assets/items/screw.png",
    "npcPrice": 1
  },
  {
    "slug": "scythe",
    "name": "Scythe",
    "sell": 169,
    "rare": true,
    "img": "public/assets/items/scythe.png",
    "npcPrice": 500
  },
  {
    "slug": "seahorse-tail",
    "name": "Seahorse Tail",
    "sell": 169,
    "rare": true,
    "img": "public/assets/items/seahorse-tail.png",
    "npcPrice": 500
  },
  {
    "slug": "seal-tail",
    "name": "Seal Tail",
    "sell": 97,
    "rare": false,
    "img": "public/assets/items/seal-tail.png",
    "npcPrice": 147
  },
  {
    "slug": "drop-seed",
    "name": "Seed",
    "sell": 2,
    "rare": false,
    "img": "public/assets/items/drop-seed.png",
    "npcPrice": 1
  },
  {
    "slug": "ski-poles",
    "name": "Ski Poles",
    "sell": 250,
    "rare": true,
    "img": "public/assets/items/ski-poles.png",
    "npcPrice": 1000
  },
  {
    "slug": "slow-tail",
    "name": "Slow Tail",
    "sell": 124,
    "rare": false,
    "img": "public/assets/items/slow-tail.png",
    "npcPrice": 225
  },
  {
    "slug": "small-stone",
    "name": "Small Stone",
    "sell": 2,
    "rare": false,
    "img": "public/assets/items/small-stone.png",
    "npcPrice": 1
  },
  {
    "slug": "snake-tail",
    "name": "Snake Tail",
    "sell": 67,
    "rare": false,
    "img": "public/assets/items/snake-tail.png",
    "npcPrice": 78
  },
  {
    "slug": "snow-skis",
    "name": "Snow Skis",
    "sell": 169,
    "rare": true,
    "img": "public/assets/items/snow-skis.png",
    "npcPrice": 500
  },
  {
    "slug": "snowball",
    "name": "Snowball",
    "sell": 2,
    "rare": false,
    "img": "public/assets/items/snowball.png",
    "npcPrice": 1
  },
  {
    "slug": "squirtle-hull",
    "name": "Squirtle Hull",
    "sell": 91,
    "rare": true,
    "img": "public/assets/items/squirtle-hull.png",
    "npcPrice": 132
  },
  {
    "slug": "sticky-hand",
    "name": "Sticky Hand",
    "sell": 85,
    "rare": false,
    "img": "public/assets/items/sticky-hand.png",
    "npcPrice": 120
  },
  {
    "slug": "drop-stone-orb",
    "name": "Stone Orb",
    "sell": 29,
    "rare": false,
    "img": "public/assets/items/drop-stone-orb.png",
    "npcPrice": 17
  },
  {
    "slug": "strange-flower",
    "name": "Strange Flower",
    "sell": 83,
    "rare": true,
    "img": "public/assets/items/strange-flower.png",
    "npcPrice": 114
  },
  {
    "slug": "strange-rock",
    "name": "Strange Rock",
    "sell": 102,
    "rare": true,
    "img": "public/assets/items/strange-rock.png",
    "npcPrice": 159
  },
  {
    "slug": "strange-spike",
    "name": "Strange Spike",
    "sell": 92,
    "rare": false,
    "img": "public/assets/items/strange-spike.png",
    "npcPrice": 135
  },
  {
    "slug": "strange-thing",
    "name": "Strange Thing",
    "sell": 97,
    "rare": true,
    "img": "public/assets/items/strange-thing.png",
    "npcPrice": 147
  },
  {
    "slug": "straw",
    "name": "Straw",
    "sell": 2,
    "rare": false,
    "img": "public/assets/items/straw.png",
    "npcPrice": 1
  },
  {
    "slug": "tentacruel-tentacle",
    "name": "Tentacruel Tentacle",
    "sell": 169,
    "rare": true,
    "img": "public/assets/items/tentacruel-tentacle.png",
    "npcPrice": 500
  },
  {
    "slug": "tongue",
    "name": "Tongue",
    "sell": 154,
    "rare": false,
    "img": "public/assets/items/tongue.png",
    "npcPrice": 410
  },
  {
    "slug": "drop-tooth",
    "name": "Tooth",
    "sell": 21,
    "rare": false,
    "img": "public/assets/items/drop-tooth.png",
    "npcPrice": 8
  },
  {
    "slug": "topknot",
    "name": "Topknot",
    "sell": 97,
    "rare": false,
    "img": "public/assets/items/topknot.png",
    "npcPrice": 147
  },
  {
    "slug": "drop-ghost-trace",
    "name": "Traces of Ghost",
    "sell": 111,
    "rare": true,
    "img": "public/assets/items/drop-ghost-trace.png",
    "npcPrice": 180
  },
  {
    "slug": "venom-flute",
    "name": "Venom Flute",
    "sell": 67,
    "rare": false,
    "img": "public/assets/items/venom-flute.png",
    "npcPrice": 78
  },
  {
    "slug": "drop-water-gem",
    "name": "Water Gem",
    "sell": 2,
    "rare": false,
    "img": "public/assets/items/drop-water-gem.png",
    "npcPrice": 1
  },
  {
    "slug": "water-pendant",
    "name": "Water Pendant",
    "sell": 23,
    "rare": false,
    "img": "public/assets/items/water-pendant.png",
    "npcPrice": 10
  },
  {
    "slug": "wool-ball",
    "name": "Wool Ball",
    "sell": 63,
    "rare": false,
    "img": "public/assets/items/wool-ball.png",
    "npcPrice": 69
  },
  {
    "slug": "azure-shard",
    "name": "Azure Shard",
    "sell": 169,
    "rare": false,
    "img": "public/assets/items/azure-shard.png",
    "npcPrice": 500
  },
  {
    "slug": "cerise-shard",
    "name": "Cerise Shard",
    "sell": 169,
    "rare": false,
    "img": "public/assets/items/cerise-shard.png",
    "npcPrice": 500
  },
  {
    "slug": "corrupted-ice-orb",
    "name": "Corrupted Ice Orb",
    "sell": 23,
    "rare": false,
    "img": "public/assets/items/corrupted-ice-orb.gif",
    "npcPrice": 10
  },
  {
    "slug": "corrupted-pot-of-moss-bug",
    "name": "Corrupted Pot of Moss Bug",
    "sell": 23,
    "rare": false,
    "img": "public/assets/items/corrupted-pot-of-moss-bug.gif",
    "npcPrice": 10
  },
  {
    "slug": "cyan-nightmare-gem",
    "name": "Cyan Nightmare Gem",
    "sell": 169,
    "rare": false,
    "img": "public/assets/items/cyan-nightmare-gem.png",
    "npcPrice": 500
  },
  {
    "slug": "farfetchd-stick",
    "name": "Farfetch'd Stick",
    "sell": 23,
    "rare": false,
    "img": "public/assets/items/farfetchd-stick.png",
    "npcPrice": 10
  },
  {
    "slug": "googles",
    "name": "Googles",
    "sell": 169,
    "rare": false,
    "img": "public/assets/items/googles.png",
    "npcPrice": 500
  },
  {
    "slug": "harlequin-shard",
    "name": "Harlequin Shard",
    "sell": 169,
    "rare": false,
    "img": "public/assets/items/harlequin-shard.png",
    "npcPrice": 500
  },
  {
    "slug": "malefic-essence",
    "name": "Malefic Essence",
    "sell": 169,
    "rare": false,
    "img": "public/assets/items/malefic-essence.png",
    "npcPrice": 500
  },
  {
    "slug": "metal-scraps",
    "name": "Metal Scraps",
    "sell": 23,
    "rare": false,
    "img": "public/assets/items/metal-scraps.png",
    "npcPrice": 10
  },
  {
    "slug": "naturia-essence",
    "name": "Naturia Essence",
    "sell": 23,
    "rare": false,
    "img": "public/assets/items/naturia-essence.png",
    "npcPrice": 10
  },
  {
    "slug": "neutral-essence",
    "name": "Neutral Essence",
    "sell": 23,
    "rare": false,
    "img": "public/assets/items/neutral-essence.png",
    "npcPrice": 10
  },
  {
    "slug": "nightmare-gem",
    "name": "Nightmare Gem",
    "sell": 23,
    "rare": false,
    "img": "public/assets/items/nightmare-gem.png",
    "npcPrice": 10
  },
  {
    "slug": "nightmare-ore",
    "name": "Nightmare Ore",
    "sell": 23,
    "rare": false,
    "img": "public/assets/items/nightmare-ore.png",
    "npcPrice": 10
  },
  {
    "slug": "psychic-mustache",
    "name": "Psychic Mustache",
    "sell": 23,
    "rare": false,
    "img": "public/assets/items/psychic-mustache.png",
    "npcPrice": 10
  },
  {
    "slug": "psycraft-essence",
    "name": "Psycraft Essence",
    "sell": 23,
    "rare": false,
    "img": "public/assets/items/psycraft-essence.png",
    "npcPrice": 10
  },
  {
    "slug": "seavell-essence",
    "name": "Seavell Essence",
    "sell": 23,
    "rare": false,
    "img": "public/assets/items/seavell-essence.png",
    "npcPrice": 10
  },
  {
    "slug": "tm-disk-piece",
    "name": "TM Disk Piece",
    "sell": 1,
    "rare": false,
    "img": "public/assets/items/tm-disk-piece.png",
    "npcPrice": 0
  },
  {
    "slug": "rare-pokemon-picture",
    "name": "Rare Pokémon Picture",
    "sell": 400,
    "rare": true,
    "img": "public/assets/items/rare-pokemon-picture.png",
    "npcPrice": 5000
  },
  {
    "slug": "pheromone",
    "name": "Strange Pheromone",
    "sell": 600,
    "rare": false,
    "img": "public/assets/items/pheromone.png",
    "npcPrice": 1000000
  }
];
export const IMPORTED_STONES = [
  {
    "slug": "ancient-stone",
    "name": "Ancient Stone",
    "price": 50000,
    "type": null,
    "desc": "Evolui pokémons (Ancient Stone).",
    "img": "public/assets/items/ancient-stone.gif",
    "rare": true
  },
  {
    "slug": "cocoon-stone",
    "name": "Cocoon Stone",
    "price": 5000,
    "type": "inseto",
    "desc": "Evolui pokémons (Cocoon Stone).",
    "img": "public/assets/items/cocoon-stone.gif",
    "rare": true
  },
  {
    "slug": "crystal-stone",
    "name": "Crystal Stone",
    "price": 5000,
    "type": "pedra",
    "desc": "Evolui pokémons (Crystal Stone).",
    "img": "public/assets/items/crystal-stone.gif",
    "rare": true
  },
  {
    "slug": "darkness-stone",
    "name": "Darkness Stone",
    "price": 5000,
    "type": "sombrio",
    "desc": "Evolui pokémons (Darkness Stone).",
    "img": "public/assets/items/darkness-stone.gif",
    "rare": true
  },
  {
    "slug": "earth-stone",
    "name": "Earth Stone",
    "price": 5000,
    "type": "terra",
    "desc": "Evolui pokémons (Earth Stone).",
    "img": "public/assets/items/earth-stone.gif",
    "rare": true
  },
  {
    "slug": "enigma-stone",
    "name": "Enigma Stone",
    "price": 5000,
    "type": "psíquico",
    "desc": "Evolui pokémons (Enigma Stone).",
    "img": "public/assets/items/enigma-stone.gif",
    "rare": true
  },
  {
    "slug": "feather-stone",
    "name": "Feather Stone",
    "price": 5000,
    "type": "voador",
    "desc": "Evolui pokémons (Feather Stone).",
    "img": "public/assets/items/feather-stone.png",
    "rare": true
  },
  {
    "slug": "fire-stone",
    "name": "Fire Stone",
    "price": 5000,
    "type": "fogo",
    "desc": "Evolui pokémons (Fire Stone).",
    "img": "public/assets/items/fire-stone.gif",
    "rare": true
  },
  {
    "slug": "heart-stone",
    "name": "Heart Stone",
    "price": 5000,
    "type": "fada",
    "desc": "Evolui pokémons (Heart Stone).",
    "img": "public/assets/items/heart-stone.gif",
    "rare": true
  },
  {
    "slug": "ice-stone",
    "name": "Ice Stone",
    "price": 5000,
    "type": "gelo",
    "desc": "Evolui pokémons (Ice Stone).",
    "img": "public/assets/items/ice-stone.gif",
    "rare": true
  },
  {
    "slug": "leaf-stone",
    "name": "Leaf Stone",
    "price": 5000,
    "type": "planta",
    "desc": "Evolui pokémons (Leaf Stone).",
    "img": "public/assets/items/leaf-stone.gif",
    "rare": true
  },
  {
    "slug": "metal-stone",
    "name": "Metal Stone",
    "price": 50000,
    "type": null,
    "desc": "Evolui pokémons (Metal Stone).",
    "img": "public/assets/items/metal-stone.png",
    "rare": true
  },
  {
    "slug": "punch-stone",
    "name": "Punch Stone",
    "price": 5000,
    "type": "lutador",
    "desc": "Evolui pokémons (Punch Stone).",
    "img": "public/assets/items/punch-stone.gif",
    "rare": true
  },
  {
    "slug": "rock-stone",
    "name": "Rock Stone",
    "price": 5000,
    "type": "pedra",
    "desc": "Evolui pokémons (Rock Stone).",
    "img": "public/assets/items/rock-stone.gif",
    "rare": true
  },
  {
    "slug": "thunder-stone",
    "name": "Thunder Stone",
    "price": 5000,
    "type": "elétrico",
    "desc": "Evolui pokémons (Thunder Stone).",
    "img": "public/assets/items/thunder-stone.gif",
    "rare": true
  },
  {
    "slug": "venom-stone",
    "name": "Venom Stone",
    "price": 5000,
    "type": "veneno",
    "desc": "Evolui pokémons (Venom Stone).",
    "img": "public/assets/items/venom-stone.gif",
    "rare": true
  },
  {
    "slug": "water-stone",
    "name": "Water Stone",
    "price": 5000,
    "type": "água",
    "desc": "Evolui pokémons (Water Stone).",
    "img": "public/assets/items/water-stone.gif",
    "rare": true
  },
  {
    "slug": "moon-stone",
    "name": "Moon Stone",
    "price": 5000,
    "type": "fada",
    "desc": "Evolui pokémons (Moon Stone).",
    "img": "public/assets/items/moon-stone.png",
    "rare": false
  },
  {
    "slug": "sun-stone",
    "name": "Sun Stone",
    "price": 5000,
    "type": "planta",
    "desc": "Evolui pokémons (Sun Stone).",
    "img": "public/assets/items/sun-stone.png",
    "rare": false
  },
  {
    "slug": "rough-gemstone",
    "name": "Rough Gemstone",
    "price": 5000,
    "type": null,
    "desc": "Evolui pokémons (Rough Gemstone).",
    "img": "public/assets/items/rough-gemstone.png",
    "rare": false
  }
];
export const IMPORTED_ITEM_BY_SLUG = Object.fromEntries([...IMPORTED_LOOT, ...IMPORTED_STONES].map(i => [i.slug, i]));

